const add = (selector, className) => {
  document.querySelectorAll(selector).forEach((element) => {
    element.classList.add(className);
  });
};

const addClosest = (selector, closestSelector, className) => {
  document.querySelectorAll(selector).forEach((element) => {
    element.closest(closestSelector)?.classList.add(className);
  });
};

const addPropertyCardHooks = () => {
  document
    .querySelectorAll('[data-testid^="property-card-"]:not([data-testid^="property-card-save-"])')
    .forEach((element) => {
      element.classList.add('stez-property-card');

      const testId = element.getAttribute('data-testid') || '';
      const id = testId.replace(/^property-card-/, '').replace(/[^a-zA-Z0-9_-]/g, '-');
      if (id) element.classList.add(`stez-property-card-${id}`);
    });
};

const applyTestingHooks = () => {
  document.body.classList.add('stez-body');
  document.getElementById('root')?.classList.add('stez-root');

  add('[data-testid="site-nav"]', 'stez-nav');
  add('[data-testid="nav-logo"]', 'stez-nav-logo');
  add('[data-testid="nav-mobile-menu"]', 'stez-nav-mobile');
  add('[data-testid="site-footer"]', 'stez-footer');
  add('[data-testid="footer-wordmark"]', 'stez-footer-wordmark');

  add('[data-testid="home-hero"]', 'stez-home-hero');
  addClosest('[data-testid="home-hero"]', 'main', 'stez-page-home');
  add('[data-testid="home-featured-grid"]', 'stez-home-featured-grid');
  addClosest('[data-testid="home-featured-grid"]', 'section', 'stez-home-featured');
  add('[data-testid="home-collections-scroller"]', 'stez-home-collections-scroller');
  addClosest('[data-testid="home-collections-scroller"]', 'section', 'stez-home-collections');
  add('[data-testid="home-testimonial"]', 'stez-home-testimonial');
  add('[data-testid="home-host-banner"]', 'stez-home-host');

  add('[data-testid="props-filter-bar"]', 'stez-props-filters');
  addClosest('[data-testid="props-filter-bar"]', 'main', 'stez-page-properties');
  add('[data-testid="props-grid"]', 'stez-props-grid');
  addClosest('[data-testid="props-grid"]', 'section', 'stez-props-results');
  add('[data-testid="props-map"]', 'stez-props-map');

  add('[data-testid="detail-root"]', 'stez-page-property-detail');
  add('[data-testid="detail-title"]', 'stez-detail-title');
  add('[data-testid="detail-gallery"]', 'stez-detail-gallery');
  add('[data-testid="detail-booking-widget"]', 'stez-detail-booking');
  addClosest('[data-testid="detail-booking-widget"]', 'section', 'stez-detail-content');

  add('[data-testid="about-root"]', 'stez-page-about');
  add('[data-testid="about-hero"]', 'stez-about-hero');
  add('[data-testid="contact-root"]', 'stez-page-contact');
  add('[data-testid="contact-form"]', 'stez-contact-form');
  add('[data-testid="faq-root"]', 'stez-page-faq');
  add('[data-testid="terms-root"]', 'stez-page-terms');
  add('[data-testid="terms-toc"]', 'stez-terms-toc');
  add('[data-testid="policies-root"]', 'stez-page-policies');
  add('[data-testid="hostplan-root"]', 'stez-page-hostplan');

  add('[data-testid="account-sidebar"]', 'stez-account-sidebar');
  add('[data-testid="dashboard-root"]', 'stez-account-dashboard');

  addPropertyCardHooks();
};

const ensureOverrideStylesheet = () => {
  if (document.querySelector('link[data-stez-testing-overrides]')) return;

  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = `/testing-overrides.css?v=${Date.now()}`;
  link.dataset.stezTestingOverrides = 'true';
  document.head.appendChild(link);
};

export const installTestingHooks = () => {
  ensureOverrideStylesheet();
  applyTestingHooks();

  const observer = new MutationObserver(() => applyTestingHooks());
  observer.observe(document.getElementById('root') || document.body, {
    childList: true,
    subtree: true,
  });
};
